
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { ProcessTypeEnum, QueryOperator } from '@/libs/Api';
import EscalationGroupSelect from '@/libs/common/components-smart/EscalationGroupSelect.vue';
import { QuestionEscalationModel } from '@/libs/audits/model/question-escalation-model';
import { auditEscalationGroupsStore } from '@/libs/audit-escalation-groups/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({
    components: { EscalationGroupSelect },
})
export default class QuestionEscalation extends Page {
    protected ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;
    protected auditId: string | null | undefined = null;
    protected faultTypeId: string | null | undefined = null;
    protected escalationGroupId: string | null | undefined = null;

    @Prop() value!: QuestionEscalationModel;

    mounted() {
        this.auditId = this.value.auditId;
        this.faultTypeId = this.value.faultTypeId;
        this.escalationGroupId = this.value.escalationGroupId;
        if (this.auditId) {
            this.onLoadEscalationGroups();
        }
    }

    onAuditChange() {
        this.faultTypeId = null;
        this.escalationGroupId = null;
        this.onLoadEscalationGroups();
        this.emit();
    }

    onFaultTypeChange() {
        this.emit();
    }

    onEscalationGroupChange() {
        this.emit();
    }

    private onLoadEscalationGroups() {
        auditEscalationGroupsStore.dispatch(
            CrudAction.GetAll,
            createCrudQueryPayload(
                undefined,
                [
                    {
                        field: 'auditId',
                        op: QueryOperator.In,
                        comparand: Array.isArray(this.auditId) ? this.auditId : [this.auditId],
                    },
                ],
                undefined,
                false,
                'EscalationGroupSelect'
            )
        );
    }

    private emit() {
        this.$emit('change', {
            auditId: this.auditId,
            faultTypeId: this.faultTypeId,
            escalationGroupId: this.escalationGroupId,
        } as QuestionEscalationModel);
    }
}
